import SSBadge from "@core-components/Badge";
import Icon from "@core-components/icon/Icon";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { EBreakpoints, useBreakpoint } from "@hooks/useBreakpoint";
import { Text } from "@mantine/core";
import { EPaymentMethod } from "../models/EPaymentMethod";
import PaymentMethod from "./paymentMethod/PaymentMethod";

interface IPaypalProps {
  isChosen: boolean;
  onChoose: (method: EPaymentMethod) => void;
}

const PaypalPaymentMethod: React.FC<IPaypalProps> = ({
  isChosen,
  onChoose,
}) => {
  const { breakpoint } = useBreakpoint();
  const { t } = useAppTranslation("pages.order.basket.paymentMethod");

  return (
    <PaymentMethod
      icon={
        breakpoint <= EBreakpoints.XS ? (
          <Icon.Paypal size={80} />
        ) : (
          <Icon.PaypalFull size={80} />
        )
      }
      onChoose={() => onChoose(EPaymentMethod.PAYPAL)}
      isChosen={isChosen}
    >
      <Text className="font-inter text-primary-white">{t("paypal")}</Text>
      <SSBadge
        color={{
          background: "#3d476f",
          text: "#ffffff",
        }}
      >
        {" "}
        {t("fees")}
      </SSBadge>
    </PaymentMethod>
  );
};

export default PaypalPaymentMethod;
